"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearToggleTextKeysEnabledUserIdCookie = exports.setToggleTextKeysEnabledUserIdToCookie = exports.getToggleTextKeysUserIdFromCookie = exports.LITHIUM_TEXT_TOGGLE_COOKIE = void 0;
const SwitchUserHelper_1 = require("./SwitchUserHelper");
/**
 * Name of the cookie that will be used to store the id of the user with text keys toggle enabled.
 */
exports.LITHIUM_TEXT_TOGGLE_COOKIE = 'LithiumToggleTextKeys';
/**
 * Path of the LITHIUM_TEXT_TOGGLE_COOKIE cookie.
 */
const LITHIUM_TEXT_TOGGLE_COOKIE_PATH = '/';
/**
 * Retrieves the user's ID from the cookie.
 * @param cookie the cookie to get the user's ID from.
 */
function getToggleTextKeysUserIdFromCookie(cookie) {
    const id = (0, SwitchUserHelper_1.getCookies)(cookie).get(exports.LITHIUM_TEXT_TOGGLE_COOKIE);
    if (id) {
        const idAsNumber = Number.parseInt(id);
        if (!Number.isNaN(idAsNumber)) {
            return idAsNumber;
        }
    }
    return null;
}
exports.getToggleTextKeysUserIdFromCookie = getToggleTextKeysUserIdFromCookie;
/**
 * Function to store the user's ID on cookie
 *
 * @param userId the user's ID who has toggle text key functionality enabled
 */
function setToggleTextKeysEnabledUserIdToCookie(userId) {
    const expires = new Date();
    // expire in 24 hs
    expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
    (0, SwitchUserHelper_1.getCookies)().set(exports.LITHIUM_TEXT_TOGGLE_COOKIE, userId, {
        path: LITHIUM_TEXT_TOGGLE_COOKIE_PATH,
        expires
    });
}
exports.setToggleTextKeysEnabledUserIdToCookie = setToggleTextKeysEnabledUserIdToCookie;
/**
 * Function to remove the enable toggle text keys user's ID cookie
 */
function clearToggleTextKeysEnabledUserIdCookie() {
    (0, SwitchUserHelper_1.getCookies)().remove(exports.LITHIUM_TEXT_TOGGLE_COOKIE, { path: LITHIUM_TEXT_TOGGLE_COOKIE_PATH });
}
exports.clearToggleTextKeysEnabledUserIdCookie = clearToggleTextKeysEnabledUserIdCookie;
//# sourceMappingURL=ToggleTextKeysHelper.js.map